import { scale, type TimelineDensity } from "./scale";

/** Both timeline views place authored extents on the same linear axis. */
export function timelinePosition(startMinutes: number, durationMinutes: number, density: TimelineDensity, inset = 0) {
  return { top: scale(startMinutes, density), height: Math.max(0, scale(durationMinutes, density) - inset) };
}

/** Complement of the occupied step intervals, including leading, interior and trailing gaps. */
export function timelineGaps(steps: readonly { startMinutes: number; costMinutes: number }[], envelopeMinutes: number) {
  const gaps: { startMinutes: number; costMinutes: number }[] = [];
  let end = 0;
  for (const step of [...steps].sort((a, b) => a.startMinutes - b.startMinutes)) {
    const start = Math.min(envelopeMinutes, Math.max(0, step.startMinutes));
    if (start > end) gaps.push({ startMinutes: end, costMinutes: start - end });
    end = Math.min(envelopeMinutes, Math.max(end, step.startMinutes + step.costMinutes));
  }
  if (end < envelopeMinutes) gaps.push({ startMinutes: end, costMinutes: envelopeMinutes - end });
  return gaps;
}
